import React, { useContext, Fragment } from "react";
import { NavLink } from 'react-router-dom';
import { adres } from "../../../../functions/ulice";
import { ikona } from '../../../../functions/ikony';
import { usun_duplikaty } from '../../../../functions/grupy';
import { AuthContext } from "../../../../Context/AuthProvider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

const WspolnotaRozliczenieSeryjneTBody = (props) => {

  const { idw, wspolnota, lokale, ulice, grupy, udzialyKontaAkt, przelewyWspolnota, czynszeWspolnota, czynszeMsc, mieszkancy, zestaw } = props;

  const { role } = useContext(AuthContext);

  const drukarka = (id_user, grupa_numer) => (                        
    <FontAwesomeIcon 
        icon={faPrint} 
        className='pointer'
        onClick={()=> {zestaw(id_user, grupa_numer)}}
    />
  )
  
  const tab = udzialyKontaAkt?.map( (udzial, i) => {

    const mieszkaniec = mieszkancy.find( mieszkaniec => mieszkaniec.id_user == udzial.id_user);
    const czynsz_temp = czynszeMsc?.find( czynsz => czynsz.id_user == udzial.id_user && czynsz.grupa_numer == udzial.grupa_numer);
    
    const czynsz = czynsz_temp ? czynsz_temp?.czynsz : null

    if (czynsz?.length == 0)
      return {}

    const grupy_usera = grupy?.filter( g => g.id_user == mieszkaniec?.id_user && g.grupa_numer == udzial?.grupa_numer);

    const lokale_usera_temp = grupy_usera?.map( g => {
      return {
        id_lokal: g.id_lokal,
        id_user: g.id_user,
        grupa_numer: g.grupa_numer
      }
    });

    const lokale_usera = usun_duplikaty(lokale_usera_temp);
    
    const lokale_td = lokale_usera?.map( (lokal, i) => {
      return (
        <li key={i} className="left" >
          {
            role === "admin" ? (
              // <NavLink 
              //   to={`/mieszkancy/rozliczenia?id=${lokal?.id_user}&idw=${idw}&g=${lokal?.grupa_numer}`}
              //   style={{
              //     justifyContent: "initial"
              //   }}
              //   state={
              //     {
              //       from: {
              //         czynszeMieszkaniec: czynszeWspolnota?.find( t => t.id_user == lokal.id_user),
              //         przelewyMieszkaniec: przelewyWspolnota?.find( t => t.id_user == lokal?.id_user && t.nr_grupyUdzial == lokal.grupa_numer)?.przelewy,
              //         wspolnota: wspolnota,
              //       }
              //     }
              //   }
              // >
              <Fragment>
                {ikona(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.rodzaj)} &nbsp; {`${adres(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.ulica, ulice, lokal.id_lokal, lokale) }`} 
              </Fragment> 
              // </NavLink>
            ) : (
              <Fragment>
                {ikona(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.rodzaj)} &nbsp; {`${adres(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.ulica, ulice, lokal.id_lokal, lokale)}`} 
              </Fragment>
            )
          }
        </li>
      )
    })

    const id = role === "admin" ? ` (${mieszkaniec?.id_user}), grupa ${udzial?.grupa_numer}` : ``;

    return (
        czynsz && <tr key={i}>
          <td className="left">
            {`${mieszkaniec?.imie_nazwisko}${id}`} 
          </td>
          <td>
            <ul style={{"listStyle": "none"}}>
              {lokale_td}
            </ul>
          </td>
        </tr>
    )
  })
  return (
    <tbody>
      {tab}
    </tbody>
  )
}

export default WspolnotaRozliczenieSeryjneTBody;